import $ from 'jquery';
import ko from 'knockout';

var TaskObject = function(parent, data, availableTypes) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.objectId = ko.observable(data['objectId']);
    self.taskObject = ko.observable();
    self.contentType = ko.observable(data['contentType']);
    self.toDelete = ko.observable(false);
    self.correctObjectId = ko.observable(true);
    self.availableTypes = availableTypes;

    self.getTaskObject = function() {
        if (!isNaN(self.objectId())) {
            $.get(
                '/cabinet/ajax/task_object/' + self.contentType() + '/' + self.objectId() + '/',
                function(data) {
                    self.taskObject(data.name);
                    self.correctObjectId(true);
                }
            ).fail(function() {
                self.taskObject('');
                self.correctObjectId(false);
            });
        } else self.correctObjectId(false);
    };

    self.getTaskObject();

    self.objectId.subscribe(self.getTaskObject);
    self.contentType.subscribe(self.getTaskObject);

    self.onDelete = function() {
        self.toDelete(!self.toDelete());
    };

    self.isValidID = ko.computed(function() {
        return !self.objectId() || self.correctObjectId();
    });

    self.dump = function() {
        return {
            id: self.id(),
            objectId: self.objectId(),
            contentType: self.contentType(),
            toDelete: self.toDelete(),
        };
    };
};

var TaskObjectForm = function(objects_formset) {
    var self = this;
    var availableTypes = [{id: null, name: '--------'}].concat(objects_formset['types']);
    self.taskObjects = ko.observableArray([]);
    self.taskObjectsListData = ko.observable();

    self.onAdd = function() {
        self.taskObjects.push(new TaskObject(self, {display: true}, availableTypes));
        var elem = jQuery(event.target)
            .closest('.row')
            .prev()
            .find('> .row')
            .last();
    };

    self.taskObjects(
        objects_formset['task_objects'].map(function(t) {
            return new TaskObject(self, t, availableTypes);
        })
    );

    self.onSave = function() {
        var d = JSON.stringify(
            self.taskObjects().map(function(t) {
                return t.dump();
            })
        );
        self.taskObjectsListData(d);
    };

    self.correctObjectId = function() {
        return self.taskObjects().some(function(v) {
            return !v.correctObjectId() && !v.toDelete();
        });
    };

    self.taskObjectTypeIsEmpty = function() {
        return self.taskObjects().some(function(v) {
            return v.contentType() === null && !v.toDelete();
        });
    };
};

window.TaskObjectForm = TaskObjectForm;

var checkTaskObjectType = function(backToEdit) {
    if (!window.taskObjectForm) return true;

    if (window.taskObjectForm.taskObjectTypeIsEmpty()) {
        var dialog = $(
            '<p>Поле "Тип данных" у присоединенного объекта должно быть заполнено</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkTaskObjectId = function(backToEdit) {
    if (!window.taskObjectForm) return true;

    if (window.taskObjectForm.correctObjectId()) {
        var dialog = $(
            '<p>Проверьте правильность создания записи. Указан ID несуществующего объекта.</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var process_exit = function(e) {
    return process_exit_action(e, 'save-and-continue');
};

var process_exit_redirect = function(e) {
    return process_exit_action(e, 'save-and-redirect');
};

var process_exit_new = function(e) {
    return process_exit_action(e, 'save-and-create-new');
};

var SubmitLock = function() {
    var self = this;
    self._lock = false;

    self.lock = function() {
        $('.u-save-task, .u-save-task-close, .u-save-task-new').attr('disabled', 'disabled');
        self._lock = true;
    };

    self.unlock = function() {
        $('.u-save-task, .u-save-task-close, .u-save-task-new').removeAttr('disabled');
        self._lock = false;
    };

    self.locked = function() {
        return self._lock;
    };
};

var process_exit_action = function(e, action) {
    if (window.taskObjectForm) window.taskObjectForm.onSave();

    e.preventDefault();

    if (!window.submitLock) window.submitLock = new SubmitLock();

    window.submitLock.lock();

    var submitForm = function() {
        $('#action').attr('name', action);
        $('form.u-task-form').submit();
    };

    var backToEdit = function() {
        window.submitLock.unlock();
        $(this).dialog('close');
    };

    var WarningChain = function() {
        var self = this;

        self._idx = 0;
        self._chain = [];

        self.push = function(e) {
            self._chain.push(e);
        };

        self.checkAndSubmit = function() {
            self._idx = 0;
            if (0 == self._chain.length) submitForm();
            else self.checkNext();
        };

        self.checkNext = function() {
            if (self._idx >= self._chain.length) {
                submitForm();
                return;
            }

            var checker = self._chain[self._idx];
            self._idx++;

            if (
                checker(backToEdit, function() {
                    $(this).dialog('close');
                    self.checkNext();
                })
            )
                self.checkNext();
        };
    };

    var warningChain = new WarningChain();

    if (window.taskObjectForm) warningChain.push(checkTaskObjectType);
    warningChain.push(checkTaskObjectId);

    warningChain.checkAndSubmit();
};

export function Task() {
    if (!$('.u-task-page').length) {
        return;
    }

    $(function() {
        $('.u-task-close').click(function() {
            var task_id = $(this).data('task_id');

            if (!confirm('Вы уверены, что хотите закрыть задачу?')) {
                return false;
            }

            $.ajax({
                url: '/cabinet/ajax/tasks/' + task_id + '/close/',
                type: 'POST',
                success: function(data, textStatus, jqXHR) {
                    window.location.reload();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    alert('Произошла ошибка закрытия задачи');
                },
            });

            return false;
        });

        if ($('.u-save-task').length) {
            $('.u-save-task').click(process_exit);
            $('.u-save-task-close').click(process_exit_redirect);
            $('.u-save-task-new').click(process_exit_new);
        }
    });
}
